import React from 'react'
import Provider from './src/components/Provider'
import { stores } from './fill-config'
import { LayoutContext, ProductContext, UIProvider } from './src/contexts'
import Layout from './src/components/layout/Layout'
import { useCheckoutHydration } from './src/hooks/useCheckoutHydration'
import { useSizeVariantHydration } from './src/hooks/useSizeVariantHydration'
import useCurrencyHydration from './src/hooks/useCurrencyHydration'
import SegmentScript from './src/components/layout/SegmentScript'

const Hydration = ({ children }) => {
  useCurrencyHydration()
  useCheckoutHydration()
  useSizeVariantHydration()
  return children
}

export const wrapRootElement = ({ element }) => {
  return <Provider stores={stores}>{element}</Provider>
}

export const wrapPageElement = ({
  element,
  props: {
    pageContext: { layout, products },
  },
}) => {
  if (!layout) {
    return element
  }

  window.phill = {
    BRANCH: layout.branch,
  }

  return (
    <>
      <SegmentScript layout={layout} />
      <LayoutContext.Provider value={layout}>
        <ProductContext.Provider value={products}>
          <UIProvider>
            <Hydration>
              <Layout>{element}</Layout>
            </Hydration>
          </UIProvider>
        </ProductContext.Provider>
      </LayoutContext.Provider>
    </>
  )
}
